import { effect, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { bindStorage } from '@bynary/composables/storage';
import { TranslateService } from '@ngx-translate/core';
import { memoize } from 'lodash';


const createLanguageSignal = (translateService: TranslateService) => {

    const storedLanguage = localStorage.getItem('language');
    const initialLanguage = storedLanguage ?? translateService.currentLang;

    if (!storedLanguage) {
        localStorage.setItem('language', initialLanguage);
    }

    const language = bindStorage('language', signal(initialLanguage), { skipInitialRead: true });

    translateService.onLangChange
        .pipe(takeUntilDestroyed())
        .subscribe((event) => language.set(event.lang));

    effect(() => {
        translateService.use(language());
    });

    return language;
};

export const useLanguage = memoize(() => {
    const translateService = inject(TranslateService);
    return createLanguageSignal(translateService);
});

